const sanityClient = require('@sanity/client');

export const getClient = async () => {
  return sanityClient({
    projectId: 'dcpskzss',
    dataset: 'production',
    apiVersion: '2021-03-25',
    useCdn: false,
    token:
      'skG8H3ANEaeEaLVfeXNPNnxt7JVdSWZBgTCpiLEYWGaH3zrDJeB8szBIblLKnciNzzaGjTGWN5du3zgwgeqjmxtwt5P6NklxjtFo4jLUIzTLeMQwwj7Y0yjERmBvfVcsSwsi8UCJOmt5jYy5Vn6C5P4bXzjWc3crIUTU0ng1i8tKL6r6ORge',
  });
};

export default getClient;
